import React, { useRef } from "react";
import RotateRightIcon from "@mui/icons-material/RotateRight";

const RotatableHandler = ({ onRotate, isActive, position, dimensions }) => {
  const rotationRef = useRef(0);

  const handleRotationMouseDown = (e) => {
    e.stopPropagation();

    const cardRect = document
      .getElementById("birthday-card")
      .getBoundingClientRect();
    const centerX = position.x + dimensions.width / 2 + cardRect.left;
    const centerY = position.y + dimensions.height / 2 + cardRect.top;

    const startAngle =
      Math.atan2(e.clientY - centerY, e.clientX - centerX) * (180 / Math.PI);
    const initialRotation = rotationRef.current;

    const calculateRotation = (moveEvent) => {
      const dx = moveEvent.clientX - centerX;
      const dy = moveEvent.clientY - centerY;

      const currentAngle = Math.atan2(dy, dx) * (180 / Math.PI);
      const newRotation = initialRotation + (currentAngle - startAngle);

      rotationRef.current = newRotation;
      onRotate(newRotation);
    };

    const stopRotation = () => {
      document.removeEventListener("mousemove", calculateRotation);
      document.removeEventListener("mouseup", stopRotation);
    };

    document.addEventListener("mousemove", calculateRotation);
    document.addEventListener("mouseup", stopRotation);
  };

  return (
    isActive && (
      <div
        className="rotate-handle"
        style={{
          position: "absolute",
          bottom: "-40px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "30px",
          height: "30px",
          backgroundColor: "white",
          borderRadius: "50%",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
          cursor: "grab",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onMouseDown={handleRotationMouseDown}
      >
        <RotateRightIcon style={{ color: "#21ba45" }} />
      </div>
    )
  );
};

export default RotatableHandler;
